import { useCurrentSite } from '@hotjar/site';
import type { TileIds } from '@hotjar/webapp/domains/activation/start-page/types';
import { useDismiss } from '@hotjar/webapp/hooks/useDismiss';
import type { DismissState } from '@hotjar/webapp/hooks/useDismiss';

const APP_STATE_NAMESPACE = 'SUGGESTION_TILES';

export const useDismissTile = (tileId: TileIds): DismissState => {
  const { data: currentSite } = useCurrentSite();
  const { isDismissed, dismiss } = useDismiss(APP_STATE_NAMESPACE, tileId, {
    siteId: currentSite?.id,
  });

  return {
    isDismissed,
    dismiss,
  };
};
